import React from 'react';
import { Form } from 'react-form';
import { connect } from 'react-redux';

import UserService from 'services/UserService';
import { Text } from 'components/FormElements';
import { equalTo, required } from 'constants/InputErrors';
import { logoutUser, toggleAlertError, toggleLoading } from 'stores/actions';

class RecoverPassword extends React.Component {
  constructor() {
    super();
    this.state = {
      submitted: false,
    };

    this.submitForm = this.submitForm.bind( this );
  }

  componentDidMount() {
    if( this.props.accessToken ) {
      this.props.logoutUser();
    }
    if( this.props.isLoading ) {
      this.props.toggleLoading( false );
    }
  }

  submitForm( data ) {
    this.props.toggleLoading( true );
    UserService.changePassword( this.props.match.params.token, {
      password: data.password
    } ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.errors ) return this.props.toggleAlertError( response.errors );

      this.setState( { submitted: true } )
    } )
  }

  render() {
    return (
      <div className="page-login">
        <div className="main-body">
          <div className="body-inner">
            <div className="card bg-white">
              <div className="card-content">
                <section className="text-center">
                  <img src="assets/images/logo_smm_minsait.png" width={200} className="mb-3"/>
                </section>

                {
                  this.state.submitted ?
                    <p className="my-3 text-center">Your password has been changed successfully</p> :
                    <Form
                      onSubmit={this.submitForm}
                      validate={values => {
                        return {
                          password: required( values.password ),
                          passwordConfirmation: this.entityId ? null
                            : required( values.passwordConfirmation ) ? required( values.passwordConfirmation )
                              : equalTo( values.passwordConfirmation, values.password, 'Password' )
                        }
                      }}
                    >
                      {( { submitForm } ) =>
                        <form onSubmit={submitForm}>
                          <div className="form-group">
                            <Text field="password" className="form-control" placeholder="password" type="password"/>
                          </div>

                          <div className="form-group mt-3">
                            <Text field="passwordConfirmation" className="form-control" placeholder="passwordConfirmation"
                                  type="password"/>
                          </div>

                          <div className="text-right mt-3">
                            <button type="submit" className="btn btn-info text-uppercase">Change Password</button>
                          </div>
                        </form>
                      }
                    </Form>
                }
              </div>
            </div>

            <div className="additional-info">
              <a href="#/login">Back to login</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ( state ) => ( {
  accessToken: state.user.access_token,
  isLoading: state.settings.isLoading,
} );

const mapDispatchToProps = dispatch => ( {
  logoutUser: () => {
    dispatch( logoutUser() );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( RecoverPassword );



// WEBPACK FOOTER //
// ./routes/recover-password/index.js